module.exports = __webpack_public_path__ + "static/media/roboto-medium-webfont.2f7cc3b1.ttf";